class SignInError extends Error {
  constructor() {
    super("Invalid Credentials");
    this.status = 400;
  }
}
export default SignInError;
